/* ==========================================================================
 *  Function: Calendar
 * ======================================================================= */
function fn_components_calendar(){
	if ($( '.js-calendar' ).length){
		flatpickr.l10ns.default.firstDayOfWeek = 1;
		var calendarCheckIn = flatpickr( '.js-calendar' , {
			dateFormat: 'd/m/Y',
			disableMobile: 'true',
			locale: 'sk'
		});
	}
}
